import { site } from "../content";

export function Hero() {
  return (
    <section className="hero" aria-labelledby="intro-title">
      <h1 id="intro-title">
        {site.headline.map((line, index) => (
          <span key={line}>{index > 0 ? " " : ""}{line}</span>
        ))}
      </h1>
      <p className="hero__description">
        {site.introduction.map((line, index) => (
          <span key={line}>{index > 0 ? " " : ""}{line}</span>
        ))}
      </p>
    </section>
  );
}
